export function updateForwardingContent(content) {
	return {
		type: 'UPDATE_FORWARDING_CONTENT',
		content
	};
};